export default __webpack_public_path__ + "static/media/livechat.9d3007b9.svg";